export enum REDIRECT_URL {
    Consumer = '/',
    Developer = 'https://docs.kover.ai',
    About = '/about',
    GigEconomy = '/business/income',
    BusinessOverview = '/business',
    ECommerce = '/business/return',
    Contact = 'mailto:merchant@seel.com',
    Hiring = 'https://www.linkedin.com/jobs/search/?f_C=23758287&geoId=92000000',
    Privacy = 'https://gig.kover.ai/privacy',
    Error = '/404',
}

export enum ABOUT_PAGE_SECTION {
    Mission = '',
    Technology = 'tech',
    Team = 'team',
    Investors = 'investors',
}
